import { Agent, Message } from "@typings/dify";
import difyService from "./dify.service";

import { environment } from '@envs/environment'
import { getApiHeaders } from "./api.service";

// Utilisation des paramètres d'environnement APIM
const { apimUrl } = environment;


export const fetchAgents = async () => {
    try {
        const response = await fetch(`${apimUrl}/agents`, {
            method: 'GET',
            headers: await getApiHeaders()
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();

    } catch (error) {
        console.error('Erreur lors de la récupération des agents :', error);
        return [];
    }
}
// Récupérer la liste des agents disponibles (actifs)
export const fetchAvailableAgents = async () => {
    try {
        const response = await fetch(`${apimUrl}/agents/list`, {
            method: 'GET',
            headers: await getApiHeaders()
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error('Erreur lors de la récupération des agents :', error);

        return [];
    }
}

export const createAgent = async (agent: Agent) => {
    try {
        const response = await fetch(`${apimUrl}/agents`, {
            method: 'POST',
            headers: await getApiHeaders(),
            body: JSON.stringify({
                isActive: true,
                apiKey: agent.apiKey,
                color: agent.color,
                supportsFileUpload: agent.supportsFileUpload,
                lastUsed: new Date().toDateString,
                idGroupEntra: agent.idGroupEntra,
                translations: agent.translations,
            })
        })

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();

    } catch (error) {
        console.error('Erreur lors de la création de l\'agent :', error);
        return [];
    }
}

export const updateAgent = async (agent: Agent) => {
    try {
        const response = await fetch(`${apimUrl}/agents/${agent.id}`, {
            method: 'PATCH',
            headers: await getApiHeaders(),
            body: JSON.stringify({
                isActive: agent.isActive,
                apiKey: agent.apiKey,
                color: agent.color,
                supportsFileUpload: agent.supportsFileUpload,
                lastUsed: new Date().toDateString,
                idGroupEntra: agent.idGroupEntra,
                translations: agent.translations,
            })
        })

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();

    } catch (error) {
        console.error('Erreur lors de la mise à jour de l\'agent :', error);
        return [];
    }
}

export const deleteAgent = async (agent: Agent) => {
    try {
        const response = await fetch(`${apimUrl}/agents/${agent.id}`, {
            method: 'DELETE',
            headers: await getApiHeaders(),
            body: JSON.stringify({id: agent.id})
        })

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return response.ok;

    } catch (error) {
        console.error('Erreur lors de la supression de l\'agent :', error);
        return [];
    }
}
